import { createAction, props } from '@ngrx/store'
import { IModelUserDto } from '@adex/shared/models/dto/user.dto'
import { ISetPasswordDto } from '@adex/shared/models/dto/set-password.dto'
import { ITokenDto } from '@adex/shared/models/dto/token.dto'
import { IResetPasswordDto } from '@adex/shared/models/dto/reset-password.dto'
import { ILoginDto } from '@adex/shared/models/dto/login.dto'
import { IEmailDto } from '@adex/shared/models/dto/email.dto'
import { IGoogleLoginData } from "../../auth/models/google-auth.model";


export const createUser = createAction(
  '[Auth] Create User',
  props<{ userDto: IModelUserDto }>()
)

export const loadUser = createAction(
  '[Auth] Load User'
)

export const verifyAccount = createAction(
  '[Auth] Verify Account',
  props<{ tokenDto: ITokenDto }>()
)

export const verifyResetAccount = createAction(
  '[Auth] Verify Reset Account',
  props<{ tokenDto: ITokenDto }>()
)

export const setPassword = createAction(
  '[Auth] Set Password',
  props<{ passwordDto: ISetPasswordDto }>()
)

export const resetPassword = createAction(
  '[Auth] Reset Password',
  props<{ emailDto: IEmailDto }>()
)

export const resetPasswordCheckToken = createAction(
  '[Auth] Reset Password Check Token',
  props<{ tokenDto: ITokenDto }>()
)

export const resetPasswordSetPassword = createAction(
  '[Auth] Reset Password Set Password',
  props<{ resetPasswordDto: IResetPasswordDto }>()
)

export const login = createAction(
  '[Auth] Login',
  props<{ loginDto: ILoginDto }>()
)

export const loginGoogle = createAction(
  '[Auth] Login Google',
  props<{ data: IGoogleLoginData }>()
)
